const withoutTrailingSlash = (url: string | undefined) => (url ?? '').trim().replace(/\/+$/, '');

// Peoply Kariyer's own domain (e.g. https://myjobs.ai; mirrors the server's JOBS_SITE_URL): the
// public listings at its root, the candidate area and the candidates' sign-in / sign-up. Empty →
// they stay on this site (listings under /jobs).
export const JOBS_SITE_URL = withoutTrailingSlash(import.meta.env.VITE_JOBS_SITE_URL);

// Peoply's own site (mirrors the server's FRONTEND_URL): the HR app, the companies' sign-in /
// sign-up and Peoply's pages, linked from the listings domain. Empty → this site.
export const PEOPLY_SITE_URL = withoutTrailingSlash(import.meta.env.VITE_PEOPLY_SITE_URL);

// The public listings page, from anywhere.
export const PUBLIC_JOBS_HOME_URL = JOBS_SITE_URL ? `${JOBS_SITE_URL}/` : '/jobs';

// Peoply's public address, in its pages' SEO tags (canonical, hreflang, Open Graph, JSON-LD).
export const PEOPLY_PUBLIC_URL = 'https://peoply.ai';
export const PEOPLY_SITE_NAME = 'Peoply';
